import React from "react";
import { Table } from "reactstrap";
import "./BenefitTableElement.scss";

const BenefitTableElement = ({
  formState,
  tableData,
  handleDel,
  handleEdit,
}) => {
  const tableColumns = ["#", "Country", "Type", "Benefit", "Value"];

  return (
    <div className="table-responsive mb-3">
      <Table
        className="table-bordered align-middle table-nowrap mb-0"
        style={{ borderColor: "#d3d3d3" }}
      >
        <thead className="table-light" style={{ borderColor: "#d3d3d3" }}>
          <tr>
            {tableColumns?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.length === 0 ? (
            <tr>
              <td colSpan="5">No benefit added yet, please add one to view.</td>
            </tr>
          ) : (
            tableData?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className="d-flex align-items-center">
                      {index + 1}.
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      {item?.country}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      {item?.type}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      {item?.benefit}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      {item?.value}
                    </div>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{
                        backgroundColor: "#0A56AE",
                        color: "#fff",
                      }}
                      name="delete"
                      onClick={() => handleEdit(item?.key)}
                      disabled={formState === "view" ? true : false}
                    >
                      Edit
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-danger"
                      name="delete"
                      onClick={() => handleDel(item?.key)}
                      disabled={formState === "view" ? true : false}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default BenefitTableElement;
